import { gql } from '@apollo/client';

export const GET_QUESTIONS_PAGINATED = gql`
  query GetQuestionsPaginated($limit: Int!, $offset: Int!) {
    getQuestionsPaginated(limit: $limit, offset: $offset) {
      questions {
        id
        prompt
        options {
          desc
          isAnswer
        }
        explanation
        tag
        label
      }
      totalCount
      hasMore
    }
  }
`;
